import { useState } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaUser, FaLock } from 'react-icons/fa';

function Login() {
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [verPassword, setVerPassword] = useState(false);
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://iacloud.iapatagonia.cl/backend/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario, contrasena })
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('usuario', JSON.stringify(data));
        localStorage.setItem('token', data.token);
        navigate('/panel');
      } else {
        setError(data.error || 'Credenciales incorrectas');
        setShake(true);
        setTimeout(() => setShake(false), 500); // quitar clase shake tras la animación
      }
    } catch (err) {
      console.error('Error al conectar:', err);
      setError('Error de conexión con el servidor');
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div className="login-bg">
      <form className={`login-card ${shake ? 'shake' : ''}`} onSubmit={handleLogin}>
        <img src="/logo.png" alt="IAPatagonia Logo" className="login-logo" />
        <h2>Iniciar sesión</h2>
        <p className="subtext">Bienvenido a la plataforma de monitoreo</p>

        <div className="input-wrapper">
          <FaUser className="input-icon" />
          <input
            type="text"
            placeholder="Usuario"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            required
          />
        </div>

        <div className="input-wrapper">
          <FaLock className="input-icon" />
          <input
            type={verPassword ? 'text' : 'password'}
            placeholder="Contraseña"
            value={contrasena}
            onChange={(e) => setContrasena(e.target.value)}
            required
          />
          <span onClick={() => setVerPassword(!verPassword)} className="eye-icon">
            {verPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <button type="submit">Ingresar</button>
        {error && <p className="login-error">{error}</p>}
        <footer>© 2025 IAPatagonia Technology. Todos los derechos reservados.</footer>
      </form>
    </div>
  );
}

export default Login;
